<template>
  <div>
   <px-venda-conjunta-vendas-dados-basicos :venda="venda" />
    <v-divider/>
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">Produto</th>
          <th>Quantidade</th>
          <th>Preço unitário</th>
          <th>Total</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in venda.produtos" :key="index">
          <td>{{ item.produto.descricao }}</td>
          <td>
            {{ item.quantidade }} {{ item.unidadeMedida.descricao }}
          </td>
          <td>{{ item.precoUnitario | currency }}</td>
          <td>{{ item.total | currency }}</td>
          <td>
            <px-detalhes-produto
              :produto="item"
              show-obs-externa/>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import VendaConjuntaVendasDadosBasicos from './VendaConjuntaVendasDadosBasicos.vue';

export default {
  props: {
    venda: Object,
  },
  components: {
    pxVendaConjuntaVendasDadosBasicos: VendaConjuntaVendasDadosBasicos,
  },
};
</script>
